import { css, styled } from "styled-components";

export const DefinitionList = styled.dl<{
  $horizontal?: boolean;
  $alternative?: boolean;
  $boldTitle?: boolean;
  $biggerSpace?: boolean;
}>`
  margin: 0;

  dd {
    margin: 0;
  }

  ${(props) =>
    props.$horizontal &&
    css`
      display: grid;
      grid-template-columns: auto 1fr;
      grid-gap: ${props.theme.spacing.xs};

      dt:after {
        content: ":";
      }
    `}

  ${(props) =>
    props.$alternative &&
    css`
      dt {
        font-weight: bold;
        margin-top: ${props.theme.spacing.s};
        font-size: 1.2em;
      }
    `}

  ${(props) =>
    props.$boldTitle &&
    css`
      dt {
        font-weight: bold;
      }
    `}

    ${(props) =>
    props.$biggerSpace &&
    props.$horizontal &&
    css`
      grid-gap: ${`${props.theme.spacing.m} ${props.theme.spacing.xs}`};
    `}
`;
